import React from "react";
import "../../screening-test/index.css";
import arrowImage from "../../../../assets/arrow.png";
import axios from "axios";
import resultImageG01 from "../../../../assets/FlatChartG01.svg";
import resultImageG02 from "../../../../assets/FlatChartG02.svg";
import resultImageO01 from "../../../../assets/FlatChartO01.svg";
import resultImageO02 from "../../../../assets/FlatChartO02.svg";
import resultImageR01 from "../../../../assets/FlatChartR01.svg";
import resultImageR02 from "../../../../assets/FlatChartR02.svg";

const faQuestions = require("../../../../utils/sensory2TestQuestionsFa.js");
const engQuestions = require("../../../../utils/scoboTestQuestionsEng.js");
const faAnswers = require("../../../../utils/scoboTestAnswersFa");
const engAnswers = require("../../../../utils/scoboTestAnswersEng");
const faTestResults = require("../../../../utils/scoboTestResultsFa.js");
const engTestResults = require("../../../../utils/scoboTestResultsEng.js");

class Sensory2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sensory2Result: null,
      autismBackground: "",
      autismDiagnosis: "",
      firstName: "",
      childAge: 0,
      gender: "",
      lastName: "",
      phoneNumber: "",
      questionsCounter: 1,
      questionsToShow: [],
      questionsSelectionByAge: [0],
      previousCount: 0,
      questionNumber: 0,
      questionsTotalNumber: 86,
      questions: {},
      screeningAnswer: [],
      screeningbooking: false,
      execute: false,
      results: {},
      finishedAnswering: false,
      resultNumber: 0,
      countryCode: "IR", // this.props.languageInput,
      testAnswersOptions: [],
      testResultsText: [],
      isLoaded: false,
      pictureSelector: "",
    };
  }

  componentDidMount = async () => {
    const response = await axios.post(
      "https://request.kidiar.com/evaluation/request",
      { testName: "SENSORY2" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.status == 0) {
      window.location.href = "/fa/panel/evaluations/list?test=SENSORY2"; // It could be changes to show some message to user
    }
    this.setState({ userId: response.data.audienceId });
    var receivedAge = response.data.age;

    if (response.data.age < 7) receivedAge = 0;
    else if (response.data.age < 37) receivedAge = 1;
    else if (response.data.age < 168) receivedAge = 2;
    else receivedAge = 3;
    this.setState({ childAge: receivedAge });
    this.setState({ questionsToShow: [].concat(faQuestions[receivedAge]) });
    this.setState({ questionsTotalNumber: faQuestions[receivedAge].length });
    this.setState({ testAnswersOptions: [...faAnswers] });
    this.setState({ testResultsText: [...faTestResults] });
  };

  questionChildNoSpeak = () => {
    this.state.questionsToShow.splice(45, 14);
    this.setState({
      questionsTotalNumber: this.state.questionsToShow.length - 1,
    });
  };

  screeningAnswerHandler = (value) => {
    this.state.questions[this.state.questionsCounter] = value;
    console.log(this.state.questions);

    if (this.state.previousCount > 0) {
      this.setState({ previousCount: this.state.previousCount - 1 });
    }

    if (this.state.questionsCounter != this.state.questionsTotalNumber) {
      this.setState({ questionsCounter: this.state.questionsCounter + 1 });
    } else {
      this.setState({ finishedAnswering: true });
      this.sendAnsweredQuestions();
    }
  };

  previousQuestionNumberHandler = () => {
    if (this.state.questionsCounter > 0) {
      this.setState({ previousCount: this.state.previousCount + 1 });
      this.setState({ questionsCounter: this.state.questionsCounter - 1 });
    }
  };

  nextQuestionNumberHandler = () => {
    if (this.state.previousCount > 0) {
      this.setState({ questionsCounter: this.state.questionsCounter + 1 });
      this.setState({ previousCount: this.state.previousCount - 1 });
    }
  };

  sendAnsweredQuestions = async () => {
    const results = await axios.post(
      "https://request.kidiar.com/evaluation/evaluate",
      {
        audienceId: this.state.userId,
        age: this.state.childAge, // 0, 1, 2, 3
        sex: this.state.gender,
        hasAutism: this.state.autismBackground,
        diagAutism: this.state.autismDiagnosis,
        questions: Object.keys(this.state.questions),
        answers: Object.values(this.state.questions),
        test: "SENSORY2",
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    console.log("server answer is: ", results.data);
    this.setState({ sensory2Result: results.data.result });
  };

  render() {
    if (this.state.sensory2Result != null) {
      if (this.state.sensory2Result.Result == 1) {
        this.setState({ pictureSelector: resultImageG02 });
      }
      if (this.state.sensory2Result.Result == 2) {
        this.setState({ pictureSelector: resultImageO02 });
      }
      if (this.state.sensory2Result.Result == 3) {
        this.setState({ pictureSelector: resultImageR02 });
      }

      return (
        <div className="result-page">
          <div className="result-page-container">
            <div className="result-page-right-wrapper flex-column align-items-center">
              <h>تبدیل نمرات مقیاس به نمرات هوشبهر</h>
              <table
                className="w-100 d-ltr"
                cellSpacing={0}
                style={{ border: "none" }}
              >
                <thead>
                  <tr>
                    <td style={{ visibility: "hidden" }}>{}</td>
                    <td>{"بسیار کمتر از دیگران"}</td>
                    <td>{"کمتر از دیگران"}</td>
                    <td>{"مشابه اکثر افراد"}</td>
                    <td>{"بیشتر از دیگران"}</td>
                    <td>{"بسیار بیشتر از دیگران"}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{"حس‌جویی"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[0] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[0] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[0] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[0] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[0] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"اجتناب حسی"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[1] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[1] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[1] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[1] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[1] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"حساسیت حسی"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[2] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[2] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[2] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[2] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[2] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"ثبت حسی"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[3] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[3] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[3] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[3] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[3] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"شنیداری"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[4] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[4] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[4] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[4] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[4] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"دیداری"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[5] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[5] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[5] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[5] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[5] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"لامسه"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[6] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[6] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[6] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[6] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[6] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"حرکتی"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[7] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[7] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[7] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[7] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[7] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"موقعیت بدن"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[8] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[8] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[8] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[8] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[8] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"دهانی"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[9] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[9] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[9] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[9] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[9] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"سلوک"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[10] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[10] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[10] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[10] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[10] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"هیجان اجتماعی"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[11] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[11] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[11] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[11] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[11] == 4 && "x"}
                    </td>
                  </tr>
                  <tr>
                    <td>{"توجه و تمرکز"}</td>
                    <td>
                      {this.state.sensory2Result.Percentiles[12] == 0 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[12] == 1 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[12] == 2 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[12] == 3 && "x"}
                    </td>
                    <td>
                      {this.state.sensory2Result.Percentiles[12] == 4 && "x"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="result-page-left-wrapper">
              <div className="result-answer-text">
                {"جدول پروفایل حسی کودک"}
              </div>
              <div className="d-flex">
                <a
                  href={`/fa/panel/evaluations/list/results?id=${this.state.userId}`}
                >
                  {" "}
                  {"رفتن به صفحه نتایج"}{" "}
                </a>
                <a href="/fa/panel"> {"بازگشت به داشبورد"} </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.finishedAnswering == true) {
      return (
        <div className="screening-test" style={{ backgroundImage: "none" }}>
          {this.state.testResultsText[0]}
        </div>
      );
    }

    return (
      <div
        className={
          this.state.countryCode == "IR"
            ? "screening-test"
            : "screening-test-eng"
        }
        style={{ backgroundImage: "none" }}
      >
        <button
          onClick={() => this.nextQuestionNumberHandler()}
          className="pushButton-next-question"
        >
          <img src={arrowImage}></img>
        </button>
        <div className="test-container">
          <div
            className="d-flex w-80 justify-content-between align-items-center"
            style={{
              height: "5%",
              color: "black",
              marginInlineStart: "10%",
              marginInlineEnd: "10%",
            }}
          >
            <div className="question-number">
              {this.state.questionsCounter}/{this.state.questionsTotalNumber}
            </div>
            {this.state.questionsCounter < 9 && (
              <div style={{ width: "75px", color: "black" }}>{"شنیداری"}</div>
            )}
            {this.state.questionsCounter >= 9 &&
              this.state.questionsCounter < 16 && (
                <div style={{ width: "75px", color: "black" }}>{"دیداری"}</div>
              )}
            {this.state.questionsCounter >= 16 &&
              this.state.questionsCounter < 27 && (
                <div style={{ width: "75px", color: "black" }}>{"لامسه"}</div>
              )}
            {this.state.questionsCounter >= 27 &&
              this.state.questionsCounter < 35 && (
                <div style={{ width: "75px", color: "black" }}>{"حرکتی"}</div>
              )}
            {this.state.questionsCounter >= 35 &&
              this.state.questionsCounter < 43 && (
                <div style={{ width: "75px", color: "black" }}>
                  {"موقعیت بدن"}
                </div>
              )}
            {this.state.questionsCounter >= 43 &&
              this.state.questionsCounter < 53 && (
                <div style={{ width: "75px", color: "black" }}>
                  {"حس دهانی"}
                </div>
              )}
            {this.state.questionsCounter >= 53 &&
              this.state.questionsCounter < 62 && (
                <div style={{ width: "75px", color: "black" }}>{"حس سلوک"}</div>
              )}
            {this.state.questionsCounter >= 62 &&
              this.state.questionsCounter < 76 && (
                <div style={{ width: "75px", color: "black" }}>
                  {"احساسات اجتماعی"}
                </div>
              )}
            {this.state.questionsCounter >= 76 &&
              this.state.questionsCounter < 87 && (
                <div style={{ width: "75px", color: "black" }}>{"حس توجه"}</div>
              )}
          </div>
          <div className="container-screening-question">
            <div className="screening-test-question">
              <p>
                {this.state.questionsToShow[this.state.questionsCounter - 1]}
              </p>
            </div>
          </div>
          <div className="container-screening-answer">
            <button
              onClick={() => this.screeningAnswerHandler(5)}
              style={{ background: "#8eaf52" }}
              className="screening-answer-option mode-bg-4"
            >
              {"تقریبا همیشه"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(4)}
              style={{ background: "#9db54d" }}
              className="screening-answer-option mode-bg-4"
            >
              {"به طور مکرر"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(3)}
              style={{ background: "#aabc5a" }}
              className="screening-answer-option mode-bg-4"
            >
              {"نیمی از زمان‌ها"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(2)}
              style={{ background: "#b1c85a" }}
              className="screening-answer-option mode-bg-4"
            >
              {"بعضی از مواقع"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(1)}
              style={{ background: "#bfd17e" }}
              className="screening-answer-option mode-bg-4"
            >
              {"تقریبا هیچوقت"}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(0)}
              style={{ background: "#c9c6c6", color: "#4d4855" }}
              className="screening-answer-option mode-bg-4"
            >
              {"صدق نمی‌کند"}
            </button>
          </div>
        </div>
        <button
          onClick={() => this.previousQuestionNumberHandler()}
          className="pushButton-previous-question"
        >
          <img src={arrowImage}></img>
        </button>
      </div>
    );
  }
}

export default Sensory2;
